/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { emptyText } from "@/config/placeholder";
import { Enum } from "@/service/supplier-meta/entity/Enum";
import { SelectOption } from "@/service/common/entity/SelectOption";
import { Any } from "@/service/common/entity/Any";
import { FormModel } from "@/service/common/entity/FormModel";
import Vue from "vue";
import cloneDeep from "lodash/cloneDeep";
import get from "lodash/get";
export function createDate(dateObj: any): Date {
  let d = new Date(dateObj);
  if (d + "" === "Invalid Date" && typeof dateObj === "string") {
    d = new Date(dateObj.replace(/-/g, "/"));
  }
  return d;
}
export function dateTimeFormat(dateObj: Date | string, format?: string) {
  if (!dateObj) {
    return "";
  }
  let fmt = format || "yyyy-mm-dd HH:MM:SS";
  const date = createDate(dateObj);
  let ret;
  const opt = {
    "y+": date.getFullYear().toString(), // 年
    "m+": (date.getMonth() + 1).toString(), // 月
    "d+": date.getDate().toString(), // 日
    "H+": date.getHours().toString(), // 时
    "M+": date.getMinutes().toString(), // 分
    "S+": date.getSeconds().toString(), // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  };
  Object.entries(opt).forEach((res: any[]) => {
    ret = new RegExp("(" + res[0] + ")").exec(fmt);
    if (ret) {
      fmt = fmt.replace(
        ret[1],
        ret[1].length === 1 ? res[1] : res[1].padStart(ret[1].length, "0")
      );
    }
  });
  return fmt;
}
export async function validateElementUiForm(form: any): Promise<{
  valid: boolean;
  messages?: string[];
}> {
  const res = await form.validate().catch(() => false);
  if (res) {
    return {
      valid: true,
    };
  } else {
    const messages: string[] = [];
    form.fields.forEach((field: any) => {
      if (field.validateMessage) {
        messages.push(field.validateMessage);
      }
    });
    return {
      valid: false,
      messages,
    };
  }
}
export function scrollElementFormErrorIntoView(form: any): HTMLElement | null {
  for (const field of form.fields) {
    if (field.label === "公司名称") {
      console.log(field);
      console.log(field.validateState);
    }
    if (field.validateState === "error") {
      const elem = field.$el as HTMLElement;
      elem.scrollIntoView();
      return elem;
    }
  }
  return null;
}

export function amountFormat(val: number | string | undefined | null): string {
  if (val === undefined || val === null) {
    return emptyText;
  }
  const str = val + "";
  const splitStrs = str.split(".");
  const intStr = splitStrs[0];
  const decimalStr = splitStrs[1] || "";
  let count = 0;
  const step = 3;
  let resStr = "";
  const formatStr = ",";
  for (let i = intStr.length - 1; i >= 0; i--) {
    count++;
    resStr = intStr[i] + resStr;
    if (count % step === 0 && i !== 0) {
      resStr = formatStr + resStr;
    }
  }
  return `${resStr}${decimalStr ? "." + decimalStr : ""}`;
}
export function bankcardNoFormat(
  val: number | string | undefined | null
): string {
  if (val === undefined || val === null) {
    return emptyText;
  }
  return (val + "").replace(/(\d{4})/g, "$1 ");
}
export function textFormat(val: any) {
  if (val === undefined || val === null || val === "") {
    return emptyText;
  }
  return val;
}

export function getStrByteLength(val: string): number {
  const str = new String(val);
  let bytesCount = 0;
  for (let i = 0, n = str.length; i < n; i++) {
    const c = str.charCodeAt(i);
    if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
      bytesCount += 1;
    } else {
      bytesCount += 2;
    }
  }
  return bytesCount;
}

export function genElementUITextLenValidator(len: number, msg?: string) {
  return (
    rules: { [x: string]: any[] },
    value: Any,
    callback: (msg?: string) => void
  ) => {
    if (value && (value + "").length > len) {
      callback(msg || `长度不能超过${len}`);
    } else {
      callback();
    }
  };
}
export function genElementUITextByteLenValidator(len: number, msg?: string) {
  return (
    rules: { [x: string]: any[] },
    value: Any,
    callback: (msg?: string) => void
  ) => {
    if (value) {
      const strByteLen = getStrByteLength(value + "");
      if (strByteLen > len) {
        callback(msg || `最大长度不能超过${len}（字节）`);
      } else {
        callback();
      }
    } else {
      callback();
    }
  };
}
export function genElementUIIntValidator(msg?: string) {
  return (
    rules: { [x: string]: any[] },
    value: Any,
    callback: (msg?: string) => void
  ) => {
    const reg = /^\d+$/;
    if (value && !reg.test(value + "")) {
      callback(msg || `请输入整数`);
    } else {
      callback();
    }
  };
}
export function genElementUIFloatValidator(decimals?: number, msg?: string) {
  return (rules: any, value: Any, callback: (msg?: string) => void) => {
    let regExp = new RegExp(`^\\d+(\\.\\d{1,${decimals}})?$`);
    if (typeof decimals === "number") {
      regExp = new RegExp(`^\\d+(\\.\\d{1,${decimals}})?$`);
    } else {
      regExp = new RegExp(`^\\d+(\\.\\d+)?$`);
    }

    if (value && !regExp.test(value + "")) {
      const errMsg =
        typeof decimals === "number"
          ? `请输入有效数值，最多保留${decimals}位小数`
          : "请输入有效数值";
      callback(msg || errMsg);
    } else {
      callback();
    }
  };
}
/**
 * 非空校验
 * @returns
 */
export function genElementUINullCharValidator(msg?: string) {
  return (rules: any, value: Any, callback: (msg?: string) => void) => {
    const reg = /^\s+$/;

    if (value && reg.test(value + "")) {
      callback(msg || "输入内容不能为空字符");
    } else {
      callback();
    }
  };
}
export function enumToOption(enums: Enum[]): SelectOption[] {
  return enums.map((e) => ({
    label: e.desc,
    value: e.code,
  }));
}

/**
 * 数据合并
 * @param obj
 * @param target
 * @param trim 是否去除字符的前后空格
 */
export function mergeData(
  obj: { [x: string]: any },
  target: { [x: string]: any },
  trim = false
) {
  Object.keys(obj).forEach((key) => {
    if (target[key] === undefined) {
      Vue.set(target, key, cloneDeep(obj[key]));
    } else if (Array.isArray(obj[key])) {
      Vue.set(target, key, cloneDeep(obj[key]));
      //mergeData(obj[key], target[key]);
    } else if (
      obj[key] &&
      target[key] &&
      typeof obj[key] === "object" &&
      typeof target[key] === "object"
    ) {
      mergeData(obj[key], target[key]);
    } else if (obj[key] && typeof obj[key] === "object") {
      Vue.set(target, key, cloneDeep(obj[key]));
    } else {
      let val = obj[key];
      if (trim && typeof val === "string") {
        val = val.trim();
      }
      Vue.set(target, key, val);
    }
  });
  return target;
}

/**
 * 数据填充(取交集)
 */
export function patchData(source: any, target: any) {
  const syncData = function (data: FormModel, key: string, path?: string) {
    if (
      data[key] &&
      typeof data[key] === "object" &&
      !Array.isArray(data[key])
    ) {
      Object.keys(data[key] as FormModel).forEach((k) => {
        const newPath = path ? `${path}.${key}` : key;
        syncData(data[key] as FormModel, k, newPath);
      });
    } else if (data[key] !== undefined) {
      const valuePath = path ? `${path}.${key}` : key;
      const value = get(source, valuePath);
      if (value !== undefined) {
        data[key] = value;
      }
    }
  };
  if (target && typeof target === "object") {
    Object.keys(target).forEach((key) => {
      syncData(target, key);
    });
  }
}

/**
 * 获取图片blob数据
 * @param url
 * @returns
 */
export function getImageBlobData(url: string): Promise<Blob> {
  const image = new Image();
  image.crossOrigin = "";
  image.src = url;
  return new Promise((resolve) => {
    image.onload = async function () {
      const canvas = document.createElement("canvas");
      canvas.width = image.width;
      canvas.height = image.height;
      const ctx = canvas.getContext("2d");
      ctx?.drawImage(image, 0, 0, canvas.width, canvas.height);
      canvas.toBlob(
        (data) => {
          resolve(data as Blob);
        },
        "image/png",
        1
      );
    };
  });
}

/**
 * 下载blob
 * @param data
 * @param name
 */
export function downloadBlob(data: Blob, name?: string) {
  const a = document.createElement("a");
  a.download = `${name || "下载.png"}`;
  a.style.display = "none";
  const linkUrl = URL.createObjectURL(data);
  a.href = linkUrl;
  document.body.appendChild(a);
  a.click();
  URL.revokeObjectURL(linkUrl);
  document.body.removeChild(a);
}

/**
 * 下载
 * @param url
 * @param name
 */
export function download(url: string, name?: string) {
  const a = document.createElement("a");
  a.download = `${name || "下载.png"}`;
  a.style.display = "none";
  a.href = url;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

/**
 * 获取带单位的文件大小
 * @param size
 * @returns
 */
export function getFileSizeWithUnit(size: number): string {
  if (typeof size !== "number") {
    return "";
  }
  const factor = 1024;
  if (size >= factor * factor) {
    // 显示MB
    return `${(Math.round((size / factor / factor) * 100) / 100)
      .toFixed(2)
      .replace(/((\.)?[0]+)$/, "")}MB`;
  } else if (size >= factor) {
    // 显示KB
    return `${(Math.round((size / factor) * 100) / 100)
      .toFixed(2)
      .replace(/((\.)?[0]+)$/, "")}KB`;
  } else {
    return `${size}B`;
  }
}

export function getFilenameFromContentDispositionHeader(
  contentDisposition: string
) {
  let needsEncodingFixup = true;
  let tmp: any = toParamRegExp("filename\\*", "i").exec(contentDisposition);

  if (tmp) {
    tmp = tmp[1];
    let filename = rfc2616unquote(tmp);
    filename = unescape(filename);
    filename = rfc5987decode(filename);
    filename = rfc2047decode(filename);
    return fixupEncoding(filename);
  }

  tmp = rfc2231getparam(contentDisposition);

  if (tmp) {
    const filename = rfc2047decode(tmp);
    return fixupEncoding(filename);
  }

  tmp = toParamRegExp("filename", "i").exec(contentDisposition);

  if (tmp) {
    tmp = tmp[1];
    let filename = rfc2616unquote(tmp);
    filename = rfc2047decode(filename);
    return fixupEncoding(filename);
  }

  function toParamRegExp(attributePattern: string, flags?: string) {
    return new RegExp(
      "(?:^|;)\\s*" +
        attributePattern +
        "\\s*=\\s*" +
        "(" +
        '[^";\\s][^;\\s]*' +
        "|" +
        '"(?:[^"\\\\]|\\\\"?)+"?' +
        ")",
      flags
    );
  }
  function stringToBytes(str: string) {
    const length = str.length;
    const bytes = new Uint8Array(length);

    for (let i = 0; i < length; ++i) {
      bytes[i] = str.charCodeAt(i) & 0xff;
    }

    return bytes;
  }
  function textdecode(encoding: string, value: string) {
    if (encoding) {
      // eslint-disable-next-line no-control-regex
      if (!/^[\x00-\xFF]+$/.test(value)) {
        return value;
      }

      try {
        const decoder = new TextDecoder(encoding, {
          fatal: true,
        });
        const buffer = stringToBytes(value);
        value = decoder.decode(buffer);
        needsEncodingFixup = false;
      } catch (e) {
        if (/^utf-?8$/i.test(encoding)) {
          try {
            value = decodeURIComponent(escape(value));
            needsEncodingFixup = false;
          } catch (err) {
            //
          }
        }
      }
    }

    return value;
  }

  function fixupEncoding(value: any) {
    if (needsEncodingFixup && /[\x80-\xff]/.test(value)) {
      value = textdecode("utf-8", value);

      if (needsEncodingFixup) {
        value = textdecode("iso-8859-1", value);
      }
    }

    return value;
  }

  function rfc2231getparam(contentDispositionStr: any) {
    const matches: any[] = [];
    let match;
    const iter = toParamRegExp("filename\\*((?!0\\d)\\d+)(\\*?)", "ig");

    while ((match = iter.exec(contentDispositionStr)) !== null) {
      // eslint-disable-next-line prefer-const
      let [, , quot, part] = match;
      let n: any = match[1];
      n = +n;
      n = parseInt(n, 10);

      if (n in matches) {
        if (n === 0) {
          break;
        }

        continue;
      }

      matches[n] = [quot, part];
    }

    const parts = [];

    for (let n = 0; n < matches.length; ++n) {
      if (!(n in matches)) {
        break;
      }

      // eslint-disable-next-line prefer-const
      let [quot, part] = matches[n];
      part = rfc2616unquote(part);

      if (quot) {
        part = unescape(part);

        if (n === 0) {
          part = rfc5987decode(part);
        }
      }

      parts.push(part);
    }

    return parts.join("");
  }

  function rfc2616unquote(value: any) {
    if (value.startsWith('"')) {
      const parts = value.slice(1).split('\\"');

      for (let i = 0; i < parts.length; ++i) {
        const quotindex = parts[i].indexOf('"');

        if (quotindex !== -1) {
          parts[i] = parts[i].slice(0, quotindex);
          parts.length = i + 1;
        }

        parts[i] = parts[i].replace(/\\(.)/g, "$1");
      }

      value = parts.join('"');
    }

    return value;
  }

  function rfc5987decode(extvalue: any) {
    const encodingend = extvalue.indexOf("'");

    if (encodingend === -1) {
      return extvalue;
    }

    const encoding = extvalue.slice(0, encodingend);
    const langvalue = extvalue.slice(encodingend + 1);
    const value = langvalue.replace(/^[^']*'/, "");
    return textdecode(encoding, value);
  }

  function rfc2047decode(value: any) {
    // eslint-disable-next-line no-control-regex
    if (!value.startsWith("=?") || /[\x00-\x19\x80-\xff]/.test(value)) {
      return value;
    }

    return value.replace(
      /=\?([\w-]*)\?([QqBb])\?((?:[^?]|\?(?!=))*)\?=/g,
      function (matches: any, charset: string, encoding: string, text: string) {
        if (encoding === "q" || encoding === "Q") {
          text = text.replace(/_/g, " ");
          // eslint-disable-next-line prettier/prettier
          text = text.replace(
            /=([0-9a-fA-F]{2})/g,
            function (match: any, hex: string) {
              return String.fromCharCode(parseInt(hex, 16));
            }
          );
          return textdecode(charset, text);
        }

        try {
          text = atob(text);
          // eslint-disable-next-line no-empty
        } catch (e) {}

        return textdecode(charset, text);
      }
    );
  }

  return "";
}
